import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, Inject, Input, Output, EventEmitter, ElementRef } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ReplaySubject } from "rxjs";
import { AppService } from "@irb/app.service";
import { ICreateSecurites, SecurityMasterService } from "../security-master/security-master.service";
import { IrbModelsEvents } from "../irb-models.events";
import { IOptionChainSelected } from "@irb/irb-option-chains/irb-option-chains.model";
import { IrbOptionChainsService } from "@irb/irb-option-chains/irb-option-chains.service";
import { IrbAppEvents } from "@irb/irb-common/events";
import { IAlertDialogData } from "@irb/app.model";

@Component({ standalone: false,
  selector: "irb-create-securities-by-symbol-dialog",
  templateUrl: "./create-securities-by-symbol-dialog.component.html",
  styleUrls: ["./create-securities-by-symbol-dialog.component.scss", "../../irb-common/styles/dialog.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CreateSecuritiesBySymbolDialogComponent implements OnInit, OnDestroy {
  @ViewChild("modelNameField") modelNameField: any;
  modelName: string = "";
  multiLineComment: string = "";
  modelDesc: string;
  modelNameInUse: boolean = false;
  modelCanResurrect: boolean = false;
  resurrectOption: string = "Restore";
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  callToActionText: string;
  callBack: Function;
  isAltWorkflow: boolean;
  canNotContinueD: boolean = true;
  parseData: any;
  requestdatas : Array<ICreateSecurites> = [];
  isTextValid: boolean = true;

  @Input()
  selectedOptionChainData: any;

  previousSelectedOptions:  Array<string>;

  @Output()
  multiLineValues = new EventEmitter<string>();

  @ViewChild('multilineTextInput') public multilineTextInput: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<CreateSecuritiesBySymbolDialogComponent>,
    public securityMasterService: SecurityMasterService,
    public as: AppService,
    public irbOptionChainsService: IrbOptionChainsService,
    @Inject(MAT_DIALOG_DATA) public mdd: any
  ) {}

  ngOnInit() {
    if (this.irbOptionChainsService.createSecurityBySymbolMultilineValues) {
      this.multiLineComment = this.irbOptionChainsService.createSecurityBySymbolMultilineValues;
    }
    if (this.selectedOptionChainData) {
      this.selectedOptionChainData.forEach((option: any) => {
        option[1].forEach((item: string) => {
          if(!this.multiLineComment.includes(item)) {
           this.multiLineComment = this.multiLineComment ? this.multiLineComment + ' ' + item : item;
          }
          });
      });
    }
      if (this.mdd && this.mdd.dropdownSearch && this.mdd.dropdownSearchValue) {
      this.multiLineComment = this.mdd.dropdownSearchValue;
    }
    setTimeout(() => {
      this.multilineTextInput.nativeElement.focus();
    });
    this.continueButtonEnable();
  }

  ngOnDestroy() {
    this.destroyed$.complete();
  }

  close() {
   this.dialogRef.close();
  }

  checkSecurities() {
    
    const ca: Array<string> = this.multiLineComment.trim().split(/\s|\n/);
    let request: any;
    for(let i= 0;i < ca.length;i++) {
      if (ca[i].trim() !== '') {
        request = {} as ICreateSecurites;
        request.securitySymbol = ca[i];
        request.customCategoryId = null;
        request.securityDescription = null;
        request.securityType = null;
        this.requestdatas.push(request);
      }
    }
    if (this.requestdatas.length !== 0) {
      this.securityMasterService.checkSecurities(this.requestdatas).subscribe((data: any) => {
        data.isCreateSecurites = true;
        let savingParams: Array<any> = [];
        let nonInventoriedsavingParams: Array<any> = [];
        let inValidSymbolCnt = 0;
        let isCashType: boolean = false;
        if(data.unRecognized.data && data.unRecognized.data.length > 0){
          for(const unRecognizedData of data.unRecognized.data){
            if(this.checkIfValidCustomSymbol(unRecognizedData.securitySymbol)){
              savingParams.push(unRecognizedData);
            }else{
              inValidSymbolCnt++;
            }
          }
           
          const inventoried = (data.Inventoried.data && data.Inventoried.data.length > 0);
          const nonInventoried = (data.NonInventoried.data && data.NonInventoried.data.length > 0);
          if(inValidSymbolCnt === data.unRecognized.data.length && !inventoried && !nonInventoried ){
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error', 
              summary: "Create New Security", 
              detail: " Invalid custom symbol(s) entered."
            });
  
            this.close();
            return;
          }

        }

       if(data.NonInventoried.data && data.NonInventoried.data.length > 0){            
            for(const nonInventoriedData of data.NonInventoried.data){              
              if(nonInventoriedData.securityType === "CASH"){
                isCashType = true;
              }else{
                nonInventoriedsavingParams.push(nonInventoriedData);
              }

            }
          }

        if(isCashType && savingParams.length === 0 && nonInventoriedsavingParams.length === 0){
          this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dTitle: "Security Result ",
            msg: " Account sweeps cannot be added to iRebal's security master.\n All account sweeps held in accounts will be treated as cash and mapped to the iRebal security with the symbol of $CASH.",
            dProceedBtnLabel: "Close",
            dType: "ERROR"
        } as IAlertDialogData);
          this.close();
          return;
        }

        if(isCashType){
          data.isCashType = isCashType;
        }

        data.unRecognized.data = savingParams;
        data.inValidSymbolCnt = inValidSymbolCnt; 
        data.NonInventoried.data = nonInventoriedsavingParams;

        let newObj = Object.assign({}, data, this.mdd);
        this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES, newObj);
      });
    }
    this.close();
  }

  onKeyUpChange() {
    this.continueButtonEnable();
  }

  private continueButtonEnable() {
    let re: RegExp = /[`@$%\^&*=()\\[\]\\';{}|\\":<>\?]/g;
    if (this.multiLineComment.trim().length !== 0) {
      this.isTextValid = !re.test(this.multiLineComment.trim());     

      this.canNotContinueD = this.isTextValid ? false : true;

      if (this.multiLineComment.includes(",")) {
        this.canNotContinueD = true;
        this.isTextValid = false;
      }
      return;
    }
    if (this.multiLineComment.length === 0) {
      this.canNotContinueD = true;
      this.isTextValid = true;
    }

  }

  sendMultiLineData() {
     this.multiLineValues.emit(this.multiLineComment);
  }

  checkIfValidCustomSymbol(unRecognizedSymbol: string)
  {
    let notAllowedSpCharSymbol ;
    let allowedSpCharSymbol ;
    let notAllowedSpCharPattern = /[^~!./#a-zA-Z0-9\s]/g;
    let allowedSpCharPattern = /[~!./#]/g;
    if(unRecognizedSymbol.match(notAllowedSpCharPattern) && unRecognizedSymbol.match(notAllowedSpCharPattern) != null)
      notAllowedSpCharSymbol = unRecognizedSymbol.match(notAllowedSpCharPattern);
    if(unRecognizedSymbol.match(allowedSpCharPattern) && unRecognizedSymbol.match(allowedSpCharPattern) != null)
      allowedSpCharSymbol = unRecognizedSymbol.match(allowedSpCharPattern);
    if((notAllowedSpCharSymbol && notAllowedSpCharSymbol.length >0) || (allowedSpCharSymbol && allowedSpCharSymbol.length > 2))
      return false;
    else
      return true;
  }
  
}
